import axios from 'axios';

import { mapCheckInDto } from 'common/utils/responseMapper';

import { ICheckIn, ICheckInResponse } from 'modules/front-desk/interfaces';
import { AlertTypes } from 'common/interfaces/alerts';
import { CustomerStatus } from 'modules/front-desk/constants/common/constants';
import { getArray } from 'common/utils/typeUtils';
import { IAttachmentImt } from 'common/interfaces/uploadFile';
import { IObject } from 'common/interfaces/common';
import { ITableParams } from 'common/interfaces/table';
import ApiService from './ApiService';

export default class CheckInService extends ApiService {
  // private checkInsList: Array<ICheckIn> = [];

  public getRecentCheckIns = async (
    clubId: string,
    entranceId: string,
    customerType: CustomerStatus | null,
    alertType: AlertTypes | null,
  ): Promise<ICheckIn[]> => {
    const config = {
      params: {
        clubId,
        entranceId,
        customerType,
        alertType,
      },
    };

    const checkIns = await axios.get(`/api/v1/check-ins`, config);

    return getArray<ICheckInResponse>(checkIns).map(mapCheckInDto);
  };

  public getCheckInInfo = (checkInId: string): Promise<ICheckInResponse> =>
    axios.get(`/api/v1/check-ins/${checkInId}`);

  public memberCheckIn = (personId: number, entranceId: string): Promise<ICheckInResponse> => {
    return axios.put(`/api/v1/front-desk/${personId}/checkins/manually`, null, {
      params: {
        entranceId,
      },
    });
  };

  public barcodeCheckIn = (barcode: string): Promise<void> => {
    return axios.get(`/api/v1/front-desk/barcode-check-in?barcode=${barcode}`);
  };

  /**
   * This checkIn used on front desk page, in checked manually block.
   * @param clientId - id of club probably?
   * @param personId - id of member to check in
   */

  /* public async updateRecentCheckIns(clientId: string, personId: number): Promise<ICheckIn[]> {
    const res: any = await new Promise(resolve => {
      setTimeout(() => {
        const members = Services.Members.getFoundGuestsList();
        const selectedMember: any = members.find(item => item.person.id === personId);

        selectedMember.createdAt = new Date().toString();
        selectedMember.checkInType = 'manual';

        // TODO This is the ICheckIn interface. Need to check props. Is id string or number?
        const checkIn = {
          id: 10 + Math.random() * (100000 + 1 - 10),
          personId: selectedMember.person.id,
          personalId: selectedMember.person.personalId,
          photoUrl: selectedMember.person.photoUrl,
          firstName: selectedMember.person.firstName,
          lastName: selectedMember.person.lastName,
          birthday: selectedMember.person.birthday,
          checkInTime: selectedMember.createdAt,
          checkInType: selectedMember.checkInType,
          personType: selectedMember.person.type,
          alerts: selectedMember.alerts,
        };

        resolve(checkIn);
      }, 800);
    });
    this.checkInsList = [res, ...this.checkInsList];
    return this.checkInsList;
  } */

  public memberKioskModeCheckIn = (
    personId: number,
    entranceId: string,
  ): Promise<ICheckInResponse> => {
    return axios.put(`/api/v1/front-desk/kiosk-mode/${personId}/checkins/manually`, null, {
      params: {
        entranceId,
      },
    });
  };

  public exportCheckInHistoryReport = (
    exportData: IObject,
    params: ITableParams,
  ): Promise<IAttachmentImt> => {
    const searchParams = this.getSearchFromTableParams(params);

    searchParams.perPage = 0;
    searchParams.page = 0;

    return axios.get('/api/v1/reports/checkin/front-desk/export', {
      params: searchParams,
    });
  };
}
